<template>
  <div :class="classNames" class="base-title" :style="mergeStyle">
    <span class="base-title__text">
      <template v-if="$slots.default">
        <slot />
      </template>
      <template v-else>
        {{ title }}
      </template>
    </span>
    <slot name="link" />
  </div>
</template>

<script>
import { pxToRem } from '@/utils'
const classList = ['small', 'default', 'medium', 'large']
export default {
  name: 'BaseTitle',
  props: {
    title: {
      type: String,
      default: '--'
    },
    size: {
      type: [String, Number],
      default: 'default'
    },
    bold: {
      type: Boolean,
      default: false
    },
    ellipsis: {
      type: Boolean,
      default: false
    },
    lineHeight: {
      type: [String, Number],
      default: '1'
    },
    block: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#303133'
    },
    prefix: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  // 加个计算属性
  computed: {
    classNames() {
      const _className = []
      if (classList.includes(this.size)) {
        _className.push('is-' + this.size)
      }

      if (this.bold) {
        _className.push('is-bold')
      }

      if (this.ellipsis) {
        _className.push('is-ellipsis')
      }

      if (this.prefix) {
        _className.push('is-prefix')
      }

      if (this.border) {
        _className.push('is-border')
      }

      return _className
    },
    mergeStyle() {
      const style = {}
      const size = pxToRem(this.size)
      if (size) {
        style.fontSize = size
      }
      if (this.lineHeight) {
        if (this.lineHeight.indexOf('px') > -1) {
          style.lineHeight = pxToRem(this.lineHeight)
        } else {
          style.lineHeight = this.lineHeight
        }
      }
      if (this.block) {
        style.display = 'block'
      }

      if (this.$slots.link) {
        style.display = 'flex'
        style.width = '100%'
        style.alignItems = 'center'
        style.justifyContent = 'space-between'
      }
      style.color = this.color
      return style
    }
  }
}
</script>

<style lang="scss" scoped>
.base-title {
  display: inline-block;
  line-height: 1;
  font-size: 16px;

  &.is-bold {
    font-weight: bold;
  }

  &.is-small {
    font-size: 14px;
  }

  &.is-medium {
    font-size: 18px;
  }

  &.is-large {
    font-size: 20px;
  }

  &.is-ellipsis {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.is-prefix .base-title__text {
    padding-left: 10px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      width: 4px;
      height: 16px;
      background: #0758ff;
      transform: translateY(-50%);
    }
  }

  &.is-border {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #dcdfe6;
  }
}
</style>
